import { Button, Layout, Menu } from 'antd';
import React, { CSSProperties, useEffect, useState } from 'react';
import { batch } from 'react-redux';
import { getFullVelocityUrl } from '../../../Helper';
import { User } from '../../../model/AccountModel';

import styles from './header.module.scss';
import {
	AlarmsIcon,
	DeviceControlIcon,
	EnrollmentIcon,
	EventsIcon,
	MenuCloseIcon,
	MenuOpenIcon,
	PhotoCallUpIcon,
	ReportingIcon,
	StatusDashboardIcon,
	StatusViewerIcon,
	WhosInsideIcon,
} from './MenuIcons';

const { Item } = Menu;
const { Sider } = Layout;

type Props = {
	collapsed: boolean;
	handleOnCollapseMenu: () => void;
};

//Avoid creating object style inline, since increases reconciliations
const user: User = getUser();
const {
	canViewEnrollmentPage,
	canViewAlarmPage,
	canViewReportsPage,
	canViewEventsPage,
	canViewWhosInside,
	canViewDevicePage,
	canViewDashboard,
	canViewPhotoCallUp,
	canViewStatusViewer,
} = user;

const companyName: string = 'Identiv, Inc.';
const fullVelocityUrl: string = getFullVelocityUrl();
const enrollmentUrl: string = `${fullVelocityUrl}Enrollment/EnrollmentManager`;
const alarmsUrl: string = `${fullVelocityUrl}Events/EventViewer`;
const eventsUrl: string = `${fullVelocityUrl}Events/FullEventViewer`;
const deviceAdminManagerUrl: string = `${fullVelocityUrl}DeviceAdmin/DeviceAdminManager`;
const statusViewerUrl: string = `${fullVelocityUrl}StatusViewer/StatusViewer`;
const whosInsideUrl: string = `${fullVelocityUrl}WhosInside/WhosInsideManager`;
const photoCallUpUrl: string = `${fullVelocityUrl}PhotoCallUp/PhotoCallUpDashboard`;
const reportsUrl: string = `${fullVelocityUrl}Reports/ReportManager`;
const statusDashboardUrl: string = `${fullVelocityUrl}Status/StatusDashboard`;

const Header: React.FC<Props> = ({ collapsed, handleOnCollapseMenu }) => {
	let activeKey: string = '-1';
	const input = document.getElementById('SelectedTab') as HTMLInputElement;
	const [buttonOnHover, setButtonOnHover] = useState<boolean>(false);
	const MenuCollapseStyle: CSSProperties = { width: '20px', fill: '#fff' };

	if (input && input.value) {
		activeKey = input.value;
	}

	const createMenuItems = (): JSX.Element[] => {
		const menuItems: JSX.Element[] = [];
		const iconsStyle: CSSProperties = { color: 'white', width: 16 };
		if (canViewEnrollmentPage) {
			menuItems.push(
				<Item key='1' className={styles.headerMenuItem}>
					<EnrollmentIcon label={_('Enrollment')} style={iconsStyle} />
					<span id='enrollmentManagerPageTab'>
						<a href={enrollmentUrl} data-leavetab={true}>
							&nbsp;{_('Enrollment')}
						</a>
					</span>
				</Item>
			);
		}
		if (canViewAlarmPage) {
			menuItems.push(
				<Item key='2' className={styles.headerMenuItem}>
					<AlarmsIcon label={_('AlarmViewer')} style={iconsStyle} />
					<span id='alarmsPageTab'>
						<a href={alarmsUrl} data-leavetab={true}>
							&nbsp;{_('AlarmViewer')}
						</a>
					</span>
				</Item>
			);
		}
		if (canViewEventsPage) {
			menuItems.push(
				<Item key='3' className={styles.headerMenuItem}>
					<EventsIcon label={_('Events')} style={iconsStyle} />
					<span id='eventsPageTab'>
						<a href={eventsUrl} data-leavetab={true}>
							&nbsp;{_('EventViewer')}
						</a>
					</span>
				</Item>
			);
		}
		if (canViewDevicePage) {
			menuItems.push(
				<Item key='4' className={styles.headerMenuItem}>
					<DeviceControlIcon label={_('DeviceControl')} style={iconsStyle} />
					<span id='deviceControlPageTab'>
						<a href={deviceAdminManagerUrl} data-leavetab={true}>
							&nbsp;{_('DeviceControl')}
						</a>
					</span>
				</Item>
			);
		}
		if (canViewStatusViewer) {
			menuItems.push(
				<Item key='5' className={styles.headerMenuItem}>
					<StatusViewerIcon label={_('StatusViewer')} style={iconsStyle} />
					<span id='statusViewerPageTab'>
						<a href={statusViewerUrl} data-leavetab={true}>
							&nbsp;{_('StatusViewer')}
						</a>
					</span>
				</Item>
			);
		}
		if (canViewWhosInside) {
			menuItems.push(
				<Item key='6' className={styles.headerMenuItem}>
					<WhosInsideIcon label={_('WhosInside')} style={iconsStyle} />
					<span id='whosInsidePageTab'>
						<a href={whosInsideUrl} data-leavetab={true}>
							&nbsp;{_('WhosInside')}
						</a>
					</span>
				</Item>
			);
		}
		if (canViewPhotoCallUp) {
			menuItems.push(
				<Item key='7' className={styles.headerMenuItem}>
					<PhotoCallUpIcon label={_('PhotoCallUp')} style={iconsStyle} />
					<span id='photoCallUpPageTab'>
						<a href={photoCallUpUrl} data-leavetab={true}>
							&nbsp;{_('PhotoCallUp')}
						</a>
					</span>
				</Item>
			);
		}
		if (canViewReportsPage) {
			menuItems.push(
				<Item key='8' className={styles.headerMenuItem}>
					<ReportingIcon label={_('Reporting')} style={iconsStyle} />
					<span id='reportingPageTab'>
						<a href={reportsUrl} data-leavetab={true}>
							&nbsp;{_('Reporting')}
						</a>
					</span>
				</Item>
			);
		}
		if (canViewDashboard) {
			menuItems.push(
				<Item key='9' className={styles.headerMenuItem}>
					<StatusDashboardIcon label={_('StatusDashboard')} style={iconsStyle} />
					<span id='statusDashboardPageTab'>
						<a href={statusDashboardUrl} data-leavetab={true}>
							&nbsp;{_('StatusDashboard')}
						</a>
					</span>
				</Item>
			);
		}
		return menuItems;
	};

	const showTitleButtonCollapseMenu = (hover: boolean) => {
		batch(() => {
			setButtonOnHover(hover);
		});
	};

	const logoStyles: CSSProperties = collapsed ? { display: 'none' } : {};
	const buttonStyles: CSSProperties = collapsed ? { marginRight: 3 } : {};

	useEffect(() => {
		document.getElementById('buttonCollapseMenu').onmouseenter = function () {
			showTitleButtonCollapseMenu(true);
		};
		document.getElementById('buttonCollapseMenu').onmouseleave = function () {
			showTitleButtonCollapseMenu(false);
		};
	}, [buttonOnHover]);

	useEffect(() => {
		batch(() => {
			setButtonOnHover(false);
		});
	}, [collapsed]);

	return (
		<>
			<Sider className={styles.headerMenuContainer} trigger={null} collapsible collapsed={collapsed} collapsedWidth={50}>
				<div className={styles.logoContainer}>
					<img alt={companyName} src={`${fullVelocityUrl}Content/Images/Identiv_Logo.png`} style={logoStyles} />
					<Button id='buttonCollapseMenu' className={styles.menuButton} type='primary' onClick={handleOnCollapseMenu} style={buttonStyles}>
						{collapsed ? (
							<MenuOpenIcon label={`${_('Menu')} ${_('Fold')}`} style={MenuCollapseStyle} />
						) : (
							<MenuCloseIcon label={`${_('Menu')} ${_('Unfold')}`} style={MenuCollapseStyle} />
						)}
					</Button>
				</div>
				<Menu
					className={styles.headerMenu}
					defaultSelectedKeys={[activeKey]}
					getPopupContainer={(element: HTMLElement) => element.parentElement}
					mode='inline'>
					{createMenuItems()}
				</Menu>
			</Sider>
			{buttonOnHover && (
				<div className={styles.hoverContainer} style={collapsed ? { marginLeft: '58px' } : { marginLeft: '208px' }}>
					<div className={styles.arrowLeft}></div>
					<div className={styles.buttonOnHover}>
						{collapsed ? <label>{_('ClickToExpandMenu')}</label> : <label>{_('ClickToCollapseMenu')}</label>}
					</div>
				</div>
			)}
		</>
	);
};

export { Header };
